import uuidv4 from '../../utils/guid'
interface Conditions {
  or?: Condition[]
  and?: Condition[]
}

interface Condition {
  field: string
  greaterThan?: string
  lessThan?: string
  equals?: string
}

export const matchesCondition = (condition: Conditions | undefined, params: object) => {
  if (!condition) return true

  const orCondition = condition.or ? condition.or.some((c) => compare(c, params)) : true

  const andCondition = condition.and ? condition.and.every((c) => compare(c, params)) : true

  return orCondition && andCondition
}

export const generateId = (idType: string) => {
  if (idType === 'numeric') {
    return Date.now() + Math.random().toString().substr(2, 9)
  } else {
    return uuidv4()
  }
}

const compare = (c: Condition, params: object) => {
  if (c.equals !== undefined) {
    return params[c.field] === c.equals
  } else if (c.greaterThan !== undefined) {
    return parseFloat(params[c.field]) >= parseFloat(c.greaterThan)
  } else if (c.lessThan !== undefined) {
    return parseFloat(params[c.field]) <= parseFloat(c.lessThan)
  } else {
    return false
  }
}
